module.exports = __webpack_public_path__ + "static/media/ico_drape.5ea9f787.svg";